<template>
    <div v-if="sourceList.length" class="custom-person">
        <div v-if="title" class="title">{{ title }}</div>
        <div class="content-wrap">
            <div class="content-item" v-for="(item,index) in sourceList.filter(i=>i.value)" :key="index">
                <div class="name">{{ item.name }}</div>
                <div>{{ item.value }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Column from "@/page/cms/column";

export default {
    name: "custom-character",
    components: {Column},
    props: {
        // 标签标题
        title: String,
        /**
         * 渲染列表
         * @type { array<{name:string; value:string}> }
         */
        sourceList: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style scoped lang="scss">
.custom-person {
    padding: 38px 28px 8px;

    .title {
        padding: 0 28px;
        line-height: 56px;
        background: $defaultGreen;
        font-size: $baseSize;
        color: #FFFFFF;
        border-radius: 50px;
        width: max-content;
        margin-bottom: 32px;
    }

    .content-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .content-item {
            flex: 0 0 44%;
            margin-bottom: 12px;
            display: flex;
            align-items: center;

            &:nth-child(odd) {
                flex: 0 0 54%;
            }

            .name {
                color: $defaultGreen;
                padding-right: 20px;
            }
        }
    }
}
</style>
